// Component_Interview_Slots_Header.tsx
import React from 'react';
import './Component_Interview_Slots_Header.css';

interface InterviewSlotsHeaderProps {
  title?: string;
  subtitle?: string;
}

function Component_Interview_Slots_Header({ 
  title = "Available interview slots",
  subtitle = "Select the date to view the available interview slots."
}: InterviewSlotsHeaderProps) {
  return (
    <div className='interview-slots-header-container'>
      <div className='interview-slots-header-content'>
        <h1 className='interview-slots-header-title'>{title}</h1>
        {/* <p className='interview-slots-header-subtitle'>{subtitle}</p> */}
      </div>
    </div>
  );
}

export default Component_Interview_Slots_Header;